import { useEffect, useState } from 'react';
import { ArrowUp } from '@phosphor-icons/react';

export default function ScrollToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 320);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!show) return null;

  return (
    <button
      type="button"
      data-testid="scroll-to-top-fab"
      onClick={scrollTop}
      aria-label="Back to top"
      className="fixed z-40 bottom-36 md:bottom-24 right-4 md:right-6 h-11 w-11 rounded-full bg-stone-900 text-white shadow-lg shadow-stone-900/20 grid place-items-center hover:bg-stone-800 active:scale-95 transition-all animate-fade-up"
    >
      <ArrowUp size={20} weight="bold" />
    </button>
  );
}
